module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-27-7de7ea5570afad168d03a897860142c8.svg";